import styled from 'styled-components';
import Skeleton from '../Skeleton/skeleton';

interface HeadshotSkeletonProps {
  width: string | number;
  ratio: number;
}

export const HeadshotSkeleton = styled(Skeleton)<HeadshotSkeletonProps>`
  height: ${({ width, ratio }) => `calc(${ratio / 100} * ${width})`};
`;
